import React from "react";

export const grain = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="grain_24px">
        <path
          d="M16 2C16 3.1 15.1 4 14 4C12.9 4 12 3.1 12 2C12 0.9 12.9 0 14 0C15.1 0 16 0.9 16 2ZM0 6C0 4.9 0.9 4 2 4C3.1 4 4 4.9 4 6C4 7.1 3.1 8 2 8C0.9 8 0 7.1 0 6ZM4 10C4 8.9 4.9 8 6 8C7.1 8 8 8.9 8 10C8 11.1 7.1 12 6 12C4.9 12 4 11.1 4 10ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12ZM10 12C8.9 12 8 12.9 8 14C8 15.1 8.9 16 10 16C11.1 16 12 15.1 12 14C12 12.9 11.1 12 10 12ZM12 10C12 8.9 12.9 8 14 8C15.1 8 16 8.9 16 10C16 11.1 15.1 12 14 12C12.9 12 12 11.1 12 10ZM10 4C8.9 4 8 4.9 8 6C8 7.1 8.9 8 10 8C11.1 8 12 7.1 12 6C12 4.9 11.1 4 10 4ZM4 2C4 0.9 4.9 0 6 0C7.1 0 8 0.9 8 2C8 3.1 7.1 4 6 4C4.9 4 4 3.1 4 2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
